import classNames from 'classnames';
import React, { FC } from 'react';

type DashboardSettingsThemeOptionLabelContainerProps = {
  selected: boolean;
  className?: string;
};

export const DashboardSettingsThemeOptionLabelContainer: FC<DashboardSettingsThemeOptionLabelContainerProps> = ({
  selected,
  children,
  className,
}) => {
  return (
    <div
      className={classNames(
        'mr-2 w-[240px] h-[72px] flex items-center bg-bedrock-light-gray rounded-lg border-2 hover:opacity-80',
        selected ? 'border-bedrock-brand-secondary' : 'border-transparent',
        className
      )}
    >
      {children}
    </div>
  );
};
